import * as types from './actionTypes';  
import brokerDealerAllocationApi from '../api/brokerDealerAllocationApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doFetchBrokerDealerAllocation(ext_id) {

  return {
    type: types.DO_FETCH_BROKERDEALER_ALLOCATION, 
    ext_id
  };
}

export function doFetchBrokerDealerAllocationRes(data) {  
  return {
    type: types.DO_FETCH_BROKERDEALER_ALLOCATION_RES, 
    data
  };
}
export function fetchBrokerDealerAllocation(ext_id) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      brokerDealerAllocationApi.doFetchBrokerDealerAllocation(ext_id).then(data => {
        if (data.error === 0) {
          dispatch(doFetchBrokerDealerAllocationRes(data));
          dispatch(doFetchBrokerDealerAllocationRes(null));
        }
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}